module.exports = __webpack_public_path__ + "img/10.b3c580f7.jpg";